/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_landing_herodescription1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 기반 개인 맞춤형 학습으로 당신의 성장을 가속화하세요`)
};

const en_landing_herodescription1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accelerate your growth with AI-powered personalized learning`)
};

const ja_landing_herodescription1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI駆動のパーソナライズされた学習で成長を加速させましょう`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const landing_herodescription1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.landing_herodescription1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("landing_herodescription1", locale)
	if (locale === "ko") return ko_landing_herodescription1(inputs)
	if (locale === "en") return en_landing_herodescription1(inputs)
	return ja_landing_herodescription1(inputs)
};
export { landing_herodescription1 as "landing_heroDescription" }